var React = require('react');

function ArrowRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1 7h18M13 1l6 6-6 6","stroke":"#fff","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"}));
}

ArrowRight.defaultProps = {"viewBox":"0 0 20 14","fill":"none"};

module.exports = ArrowRight;

ArrowRight.default = ArrowRight;
